import { Pipe, PipeTransform } from '@angular/core';
/**
 * Transformiert Properties eines Objektes in ein Array aus Key-Value-Paaren.
 *
 */
@Pipe({name: 'entries'})
export class EntriesPipe implements PipeTransform {
  transform(value, ...args: string[]): any {
    const entries = [];
    for (const key in value) {
      entries.push({key: key, value: value[key]});
    }
    return entries;
  }
}
